import { useTranslations } from 'next-intl';

import StarIcon from '@/fo/icons/base/icons/rating.svg';
import { Review } from '@/fo/ui/review/catalog/base';

import { CardWrapper } from '../CardWrapper/CardWrapper';
import { ContentBlock } from '../ContentBlock/ContentBlock';

import { styles } from './ReviewCard.styles';

export interface ReviewCardProps {
  review: Review;
  className?: string;
  onClick?: () => void;
  isConsShow?: boolean;
  isProsShow?: boolean;
  isShowMoreButtonShow?: boolean;
  isShortComment?: boolean;
  isDetailPage?: boolean;
}

export function ReviewCard({
  review,
  className,
  onClick,
  isConsShow = true,
  isProsShow = true,
  isShowMoreButtonShow = true,
  isShortComment = true,
  isDetailPage = true
}: ReviewCardProps) {
  const t = useTranslations();
  const slots = styles();

  const header = (
    <div className={slots.header()}>
      <div className={slots.headerFirstBlock()}>
        <p className={slots.authorName()}>
          {review.author.name || t('review.authorPlaceholder')}
        </p>
        <span className={slots.rating()}>
          {review.rating}
          <StarIcon className={slots.star()} />
        </span>
      </div>
      <div className={slots.headerSecondBlock()}>
        <div>{<span className={slots.date()}>{review.date}</span>}</div>
      </div>
    </div>
  );

  const content = (
    <div className={slots.content()}>
      {review.pros && isProsShow && (
        <ContentBlock
          title={t('review.labels.pros')}
          text={review.pros}
        />
      )}
      {review.cons && isConsShow && (
        <ContentBlock
          title={t('review.labels.cons')}
          text={review.cons}
        />
      )}
      {(review.comment || (!isDetailPage && review.pros)) && (
        <ContentBlock
          title={isConsShow && isProsShow ? t('review.labels.comment') : ''}
          text={
            !isDetailPage
              ? review.comment || review.pros || ''
              : review.comment || ''
          }
          isShortValue={isShortComment}
        />
      )}
    </div>
  );

  return (
    <CardWrapper
      className={className}
      header={header}
      content={content}
      actionButtonText={
        isShowMoreButtonShow ? t('review.buttons.readFullReview') : ''
      }
      onActionButtonClick={onClick}
    />
  );
}
